export default "/images/8c691e8152a02785b5928106ad3612c6.avif";